import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Team from "./pages/Team";
import Gallery from "./pages/Gallery";
import Careers from "./pages/Careers";
import JobDetails from "./pages/JobDetails";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import ForgotPassword from "./pages/admin/ForgotPassword";
import ResetPassword from "./pages/admin/ResetPassword";
import Dashboard from "./pages/admin/Dashboard";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminJobs from "./pages/admin/AdminJobs";
import AdminApplications from "./pages/admin/AdminApplications";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminAuditLogs from "./pages/admin/AdminAuditLogs";
import AdminChangePassword from "./pages/admin/AdminChangePassword";
import AdminContentManager from "./pages/admin/AdminContentManager";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes with Navbar/Footer */}
            <Route path="/" element={
              <>
                <Navbar />
                <main className="pt-20">
                  <Home />
                </main>
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navbar />
                <main className="pt-20">
                  <About />
                </main>
                <Footer />
              </>
            } />
            <Route path="/services" element={
              <>
                <Navbar />
                <main className="pt-20">
                  <Services />
                </main>
                <Footer />
              </>
            } />
            <Route path="/team" element={
              <>
                <Navbar />
                <main className="pt-20">
                  <Team />
                </main>
                <Footer />
              </>
            } />
            <Route path="/gallery" element={
              <>
                <Navbar />
                <main className="pt-20">
                  <Gallery />
                </main>
                <Footer />
              </>
            } />
            <Route path="/careers" element={
              <>
                <Navbar />
                <main className="pt-20">
                  <Careers />
                </main>
                <Footer />
              </>
            } />
            <Route path="/careers/jobs/:slug" element={
              <>
                <Navbar />
                <main className="pt-20">
                  <JobDetails />
                </main>
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Navbar />
                <main className="pt-20">
                  <Contact />
                </main>
                <Footer />
              </>
            } />
            
            {/* Admin Routes - No Navbar/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/gallery" element={
              <ProtectedRoute>
                <AdminGallery />
              </ProtectedRoute>
            } />
            <Route path="/admin/jobs" element={
              <ProtectedRoute>
                <AdminJobs />
              </ProtectedRoute>
            } />
            <Route path="/admin/applications" element={
              <ProtectedRoute>
                <AdminApplications />
              </ProtectedRoute>
            } />
            <Route path="/admin/messages" element={
              <ProtectedRoute>
                <AdminMessages />
              </ProtectedRoute>
            } />
            <Route path="/admin/settings" element={
              <ProtectedRoute>
                <AdminSettings />
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute>
                <AdminUsers />
              </ProtectedRoute>
            } />
            <Route path="/admin/audit-logs" element={
              <ProtectedRoute>
                <AdminAuditLogs />
              </ProtectedRoute>
            } />
            <Route path="/admin/change-password" element={
              <ProtectedRoute>
                <AdminChangePassword />
              </ProtectedRoute>
            } />
            <Route path="/admin/content" element={
              <ProtectedRoute>
                <AdminContentManager />
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
